import { render, staticRenderFns } from "./TCombined.vue?vue&type=template&id=39d9219d&scoped=true&"
import script from "./TCombined.vue?vue&type=script&lang=js&"
export * from "./TCombined.vue?vue&type=script&lang=js&"
import style0 from "./TCombined.vue?vue&type=style&index=0&id=39d9219d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9219d",
  null
  
)

export default component.exports